/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useRef, useState } from "react";
import "./style.less";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import logo from "@/assets/nav_logo.png";
import useWindowScrollHeight from "@/hooks/useWindowScrollHeight";
import DropDown from "./DropDown";
import DropProduct from "./DropProduct";
import { AiOutlineDown } from "react-icons/ai";
import { Animated } from "react-animated-css";
const NavBar = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathName = location?.pathname;
  const [showChild, setShowChild] = useState(-2);
  useEffect(() => {
    setTimeout(() => {
      setShowChild(-1); //animated会有初始动画，延迟渲染盒子
    }, 500);
  }, []);
  const { list } = props;
  const getScrollHeight = useWindowScrollHeight();
    const productList = [
      {
        title: "NVIDIA",
        path: "/productGpu/2",
        list: [],
        // list: [
        //   { caption: "B200", path: "/productGpu/2" },
        //   { caption: "H100", path: "/productGpu/2" },
        //   { caption: "H200", path: "/productGpu/2" },
        // ],
      },
      {
        title: "MI300X",
        path: "/productGpu/3",
        list: [],
      },
    ];
    const productAIList = [
      {
        title: "NVIDIA HGX",
        list: [
          { caption: "X8000G6I", path: "/productAI/4" },
          { caption: "X8000G6A", path: "/productAI/5" },
        ],
      },
      {
        title: "NVIDIA DGX",
        list: [
          { caption: "DGX H100", path: "/productAI/6"},
          { caption: "DGX H200", path: "/productAI/7"},
          { caption: 'DGX B200', path: "/productAI/8"}
        ],
      },
      {
        title: "NVL 72",
        list: [
          { caption: "NVL72-I2", path: "/productAI/11" },
          { caption: "NVL72-A1", path: "/productAI/12" },
        ],
      },
      {
        title: "鲲鹏",
        list: [
          { caption: "Atlas 800I A2", path: "/productAI/9" },
          { caption: "Atlas 800T A2", path: "/productAI/10" },
        ],
      },
    ];
  const navList = [
    { path: "/", key: "/", name: "首页" },
    {
      path: "",
      name: "数据中心GPU",
      children: <DropProduct productList={productList} />,
    },
    {
      path: "",
      key: "ProductAI",
      name: "AI推训服务器",
      children: <DropProduct productList={productAIList}/>,
    },
    {
      path: "",
      name: "解决方案",
      children: <DropDown />,
    },

    { path: "/aboutUs", key: "AboutUs", name: "关于我们" },
    { path: "/contact", key: "contact", name: "联系我们" },
  ];
  const navEnter = (index) => {
    setShowChild(index);
  };
  const NavClick = (path, event) => {
    console.log(path);
    if (!path) {
      event.preventDefault();
    }
  };
  return (
    <div className={`nav_bar ${getScrollHeight > 0 ? "window_scroll" : ""}`}>
      <div className="nav_warp">
        <div className="logo">
          <Link to={"/"}>
            <img src={logo} />
          </Link>
        </div>
        <div className="nav_list">
          {navList.map((val, index) => {
            return (
              <div
                className="nav_item"
                onMouseLeave={() => setShowChild(-1)}
                onMouseEnter={() => navEnter(index)}
              >
                <div className="nav_item_content">
                  <NavLink
                    onClick={(e) => NavClick(val.path, e)}
                    className={`${
                      (pathName !== "/" &&
                        val.key !== "/" &&
                        pathName.indexOf(val.key) != -1) ||
                      (pathName === "/" && val.key == "/")
                        ? "active"
                        : ""
                    }`}
                    to={val.path}
                  >
                    {val.name}
                  </NavLink>
                  {val.children ? <AiOutlineDown className="icon" /> : false}
                </div>
                {val.children ? (
                  <Animated
                    animationInDuration={300}
                    animationIn="zoomIn"
                    animationOut="zoomOut"
                    isVisible={index === showChild}
                  >
                    {showChild > -2 && (
                      <div className="drapBox">{val.children}</div>
                    )}
                  </Animated>
                ) : (
                  false
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default NavBar;
